// Extra i18n keys for cheques, accounts and polite reminders.
export const EXTRA_CHEQUES = {
  en: {
    cheque: "Cheque", cheques: "Cheques", chequeScan: "Scan cheque",
    chequeNumber: "Cheque number", payee: "Payee (beneficiary)",
    dueDate: "Due date", bankName: "Bank", purpose: "Purpose",
    chequeConfirmTitle: "Is this information correct?",
    chequeConfirmSub: "Check the extracted fields and edit if needed.",
    scanning: "Scanning cheque…", chequeSaved: "Cheque saved — we'll remind you gently 🌿",
    upcomingCheques: "Upcoming cheques", noCheques: "No cheques yet — snap one to add.",
    accounts: "Accounts", myAccounts: "My accounts", addAccount: "Add account",
    accountName: "Account name", accountType: "Type", openingBalance: "Opening balance",
    typeBank: "Bank", typeCash: "Cash", typeWallet: "Wallet", typeSavings: "Savings",
    selectBank: "Select a bank", noAccounts: "No accounts yet. Add your first one.",
    savedCheque: "Saved", pending: "Pending", paid: "Paid", cancelled: "Cancelled",
    markPaid: "Mark paid", markPending: "Mark pending", editCheque: "Edit cheque",
    chequeDetails: "Cheque details", scanAgain: "Scan again",
    wealthDistribution: "Where your money lives",
    overdraftWarn: "'{acc}' balance is only {bal}. You're adding {amt} which exceeds it. Save anyway?",
    chequePaidMsg: "Deducted from account ✓",
    chequePostponedMsg: "Postponed 7 days 🕊️",
    chequeCancelledMsg: "Marked as not cashed",
    dupAccount: "An account with this name already exists:",
  },
  ar: {
    cheque: "شيك", cheques: "الشيكات", chequeScan: "تصوير شيك",
    chequeNumber: "رقم الشيك", payee: "المستفيد",
    dueDate: "تاريخ الاستحقاق", bankName: "البنك", purpose: "الغرض",
    chequeConfirmTitle: "هل هذه المعلومات صحيحة؟",
    chequeConfirmSub: "راجع الحقول المستخرجة وعدّلها إن احتجت.",
    scanning: "جاري تحليل الشيك…", chequeSaved: "تم حفظ الشيك — سنذكّرك بلطف 🌿",
    upcomingCheques: "شيكات قادمة", noCheques: "لا شيكات بعد — صوّر واحداً لإضافته.",
    accounts: "الحسابات", myAccounts: "حساباتي", addAccount: "إضافة حساب",
    accountName: "اسم الحساب", accountType: "النوع", openingBalance: "الرصيد الافتتاحي",
    typeBank: "بنك", typeCash: "نقد", typeWallet: "محفظة", typeSavings: "ادخار",
    selectBank: "اختر البنك", noAccounts: "لا حسابات بعد. أضف أول حساب.",
    savedCheque: "تم الحفظ", pending: "معلّق", paid: "مدفوع", cancelled: "ملغى",
    markPaid: "تحديد كمدفوع", markPending: "إعادة تعليق", editCheque: "تعديل الشيك",
    chequeDetails: "تفاصيل الشيك", scanAgain: "تصوير مرة أخرى",
    wealthDistribution: "أين تعيش أموالك",
    overdraftWarn: "رصيد \"{acc}\" هو {bal} فقط، وأنت تضيف {amt}. هل تريد الحفظ رغم ذلك؟",
    chequePaidMsg: "تم الخصم من الحساب ✓",
    chequePostponedMsg: "تم التأجيل ٧ أيام 🕊️",
    chequeCancelledMsg: "تم تحديده كغير مصروف",
    dupAccount: "يوجد حساب بهذا الاسم مسبقاً:",
  },
};
